import { columnForField } from "../../Grid/columnForField";
import { nameOf } from "../../Utils/nameOf";
import Carrier from "../Carrier";
import { CarrierOverviewItem } from "./CarrierOverviewItem";

export const CARRIER_NAME_FIELD = nameOf<Carrier>("Name");

export default function CarrierGridColumns() {
  return [
    columnForField<CarrierOverviewItem>("Gsdb", {
      title: "Contract GSDB",
      width: "200px",
      locked: true,
    }),
    columnForField<CarrierOverviewItem>("Name", { width: "300px" }),
    columnForField<CarrierOverviewItem>("Street", { width: "200px" }),
    columnForField<CarrierOverviewItem>("Zip", {
      title: "Postcode",
      width: "200px",
    }),
    columnForField<CarrierOverviewItem>("City", { width: "200px" }),
    columnForField<CarrierOverviewItem>("Country"),
  ];
}
